// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HZbyG","type":"styles_type__3zfVv","choices":"styles_choices__1rDrf"};